<template>
  <form-field
    label="Contact Type"
    :validation-errors="validationErrors"
  >
    <div v-if="contactTypes.length" class="flex flex-wrap">
      <form-field-checkbox
        v-for="type in boxes"
        :key="type.id"
        :label="type.label"
        :native-value="type.include"
        v-model="type.include"
        v-on:input="selected($event, type.id)"
        size="is-small"
        class="ml-50 mb-50"
      />
    </div>
    <p v-else class="contact_type_empty">There are no Seller Contact Types, please create some on the
      <router-link :to="{name: 'settings', params: {tab: 'contacts'}}">Contact Setting Page</router-link>
    </p>
  </form-field>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldSelectContactTypes",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {
      type: Array,
      default: []
    },
    contactType: {
      type: Number,
    },
    label: {
      type: String,
      default: "Seller Contact Type"
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
    hasEmptyOption: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedValues: this.value,
      boxes: [],
    }
  },
  mounted() {
    this.contactTypes.forEach(type => {
      this.boxes.push({
        id: type.id,
        label: type.name,
        include: this.selectedValues.includes(type.id)
      });
    });
  },
  computed: {
    contactTypes() {
      if (this.contactType) {
        return this.$store.getters.contactTypes.filter(contactType => contactType.type === this.contactType);
      }

      return this.$store.getters.contactTypes;
    },
  },
  methods: {
    selected(isChecked, sellerContactTypeId) {
      if (isChecked === true) {
        this.selectedValues.push(sellerContactTypeId);
      } else {
        this.selectedValues = this.selectedValues.filter(v => v !== sellerContactTypeId);
      }

      this.handleInput(this.selectedValues)
    },
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);
      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>
.contact_type_empty {
  padding-left: 6px;
  font-size: 0.875rem;
  font-style: italic;
  line-height: 1.3;
}
</style>
